// REQ-P1-06b: アーティスト常駐バッジ件数の契約型付きAPI。

import { api, type paths } from './client';
import { ApiStatusError } from './templates';

type ArtistOfferCountResponse = NonNullable<
  paths['/artist/offer-count']['get']['responses'][200]['content']
>['application/json'];
type ArtistContractCountResponse = NonNullable<
  paths['/artist/contract-count']['get']['responses'][200]['content']
>['application/json'];

function ensureData<T>(data: T | undefined, status: number, ok: boolean): T {
  if (!ok || !data) throw new ApiStatusError(status);
  return data;
}

export async function getArtistOfferCount(): Promise<ArtistOfferCountResponse> {
  const { data, response } = await api.GET('/artist/offer-count');
  return ensureData(data as ArtistOfferCountResponse | undefined, response.status, response.ok);
}

export async function getArtistContractCount(): Promise<ArtistContractCountResponse> {
  const { data, response } = await api.GET('/artist/contract-count');
  return ensureData(data as ArtistContractCountResponse | undefined, response.status, response.ok);
}
